// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import home04Icon from "@/assets/icons/home-04.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Home04IconProps = Omit<IconProps, "name">;

export function Home04Icon(props: Home04IconProps): React.ReactNode {
  return <Icon name={home04Icon} {...props} />;
}
